import React, { CSSProperties, RefCallback, useState } from 'react';
import ReactDOM from 'react-dom';
import { usePopper } from 'react-popper';
import styled from 'styled-components';

import { styles } from '../../styles';

const Container = styled.div``;

export const TooltipContent = styled.div`
  ${styles.padding.sm};
  background-color: rgba(0, 0, 0, 0.55);
  color: white;
  ${styles.rounded.md};
  z-index: 999999;
  ${styles.text.sm};
`;

export const HoverTooltip = ({
  children,
  content,
  components: { Content = TooltipContent } = {},
}: {
  children: JSX.Element;
  content: JSX.Element;
  as: string;
  components: {
    Content?: React.ComponentType<
      {
        style?: CSSProperties;
      } & React.RefAttributes<{}>
    >;
  };
}) => {
  const [show, setShow] = useState(false);
  const [parentRef, setParentRef] = useState<HTMLElement>(null);
  const [childRef, setChildRef] = useState<HTMLElement>(null);

  const popper = usePopper(parentRef, childRef, {
    placement: 'bottom',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 10],
        },
      },
    ],
  });

  return (
    <>
      <Container
        ref={setParentRef}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        {children}
      </Container>
      {show &&
        ReactDOM.createPortal(
          <Content
            ref={setChildRef as RefCallback<any>}
            style={popper.styles.popper}
            {...popper.attributes.popper}
          >
            {content}
          </Content>,
          document.body
        )}
    </>
  );
};
